import { Accordion, Icon } from 'semantic-ui-react';
import { observer } from 'mobx-react-lite';
import { useStore } from '../../../../app/stores/store';
import { useEffect, useState } from 'react';
import { IFormDetails } from '../../../../app/stores/dashboardConfiguration/types';
import AccordionContent from './accordionContent';
import './styles.css';
import { datagridMasterElementType } from '../dataGrid/type';

function DataGridWithForm() {
  const { DashboardConfigurationStore, sidebarStore } = useStore();
  const [selectedFormMetaData, setSelectedFormMetaData] = useState<string[]>(
    [],
  );
  const [selectedTableMetaData, setSelectedTableMetaData] = useState<string[]>(
    [],
  );
  const [formMetaDataList, setformMetaDataList] = useState<
    { key: string; text: string; value: string }[]
  >([]);
  const [tableMetaDataList, setTableMetaDataList] = useState<
    { key: string; text: string; value: string }[]
  >([]);
  const [showCriteria, setShowCriteria] = useState<
    { elementId: string; criteria: { type: string; value: string }[] }[]
  >([]);
  const [activeIndex, setActiveIndex] = useState(0);

  const { tableWithForm, GETMasterMetaData } = DashboardConfigurationStore;

  useEffect(() => {
    let tempShowCriteria: {
      elementId: string;
      criteria: { type: string; value: string }[];
    }[] = [];
    let tempMasterElement = JSON.parse(
      tableWithForm?.tableMasterElement || '[]',
    );
    tempMasterElement?.forEach((data: any) => {
      if (data?.criteria) {
        tempShowCriteria?.push({
          elementId: data.elementId,
          criteria: data?.criteria,
        });
      }
    });
    setShowCriteria(tempShowCriteria);
  }, [tableWithForm?.tableMasterElement]);

  const metadataSetHandler = (tempMasterElement: any[], options: any) => {
    let tempMetaDataValue: string[] = [];
    let tempMetaDataList: { key: string; text: string; value: string }[] = [];
    options?.forEach((data: IFormDetails) => {
      tempMasterElement?.forEach(
        (selectedData: { elementId: string; mode: number | undefined }) => {
          if (
            selectedData?.elementId === data.elementId &&
            selectedData?.mode !== 2 &&
            selectedData?.mode !== undefined
          ) {
            tempMetaDataValue?.push(data.elementName);
          }
        },
      );
      tempMetaDataList?.push({
        key: data.elementId,
        text: data.elementName,
        value: data.elementName,
      });
    });

    return { tempMetaDataValue, tempMetaDataList };
  };

  useEffect(() => {
    const value = {
      masterId: '820682a2-4c97-4afc-b6a4-c3d155284da2',
      title: 'Items',
      icon: '',
    };
    const masterList = [...sidebarStore.masterFormList];
    const isDuplicate = masterList.some(
      (item) => item.masterId === value.masterId,
    );
    if (!isDuplicate) masterList.push(value);
    let data1: any[] = [];
    masterList?.forEach((data) => {
      const { masterId, title } = data;
      data1?.push({
        key: masterId,
        value: title,
        text: title,
      });
    });
    const filteredData = data1.filter(
      (item: any) => item.key !== '820682a2-4c97-4afc-b6a4-c3d155284da2',
    );
    DashboardConfigurationStore.tableWithForm.formOptions = data1;
    DashboardConfigurationStore.tableWithForm.tableOptions = filteredData;
    // eslint-disable-next-line
  }, [sidebarStore.masterFormList]);

  useEffect(() => {
    (async () => {
      if (!tableWithForm.formMasterId) return;
      let metaDataList: IFormDetails[] = await GETMasterMetaData(
        tableWithForm.formMasterId,
      );

      if (metaDataList?.length) {
        DashboardConfigurationStore.tableWithForm.formMetadataOptions =
          metaDataList;
      }
    })();
    // eslint-disable-next-line
  }, [tableWithForm.formMasterId]);

  useEffect(() => {
    (async () => {
      if (!tableWithForm.tableMasterId) return;

      let metaDataList: IFormDetails[] = await GETMasterMetaData(
        tableWithForm.tableMasterId,
      );

      if (metaDataList?.length) {
        DashboardConfigurationStore.tableWithForm.tableMetadataOptions =
          metaDataList;
      }
    })();
    // eslint-disable-next-line
  }, [tableWithForm.tableMasterId]);

  useEffect(() => {
    let tempMasterElement = JSON.parse(
      tableWithForm?.formMasterElement || '[]',
    );
    let { tempMetaDataList, tempMetaDataValue } = metadataSetHandler(
      tempMasterElement,
      tableWithForm.formMetadataOptions,
    );

    setformMetaDataList(tempMetaDataList);
    setSelectedFormMetaData(tempMetaDataValue);
    // eslint-disable-next-line
  }, [tableWithForm.formMetadataOptions]);

  useEffect(() => {
    let tempMasterElement = JSON.parse(
      tableWithForm?.tableMasterElement || '[]',
    );
    let { tempMetaDataList, tempMetaDataValue } = metadataSetHandler(
      tempMasterElement,
      tableWithForm.tableMetadataOptions,
    );

    setTableMetaDataList(tempMetaDataList);
    setSelectedTableMetaData(tempMetaDataValue);
    // eslint-disable-next-line
  }, [tableWithForm.tableMetadataOptions]);

  const setDataGridMetaData = (_event: any, data: any) => {
    const tableMasterElement = JSON.parse(tableWithForm?.tableMasterElement);
    const dataValuesSet = new Set(data.value);
    const tempMasterElementMap: any = {};
    tableWithForm.tableMetadataOptions?.forEach((tempData: any) => {
      const { elementId, elementName, elementValue, elementType } = tempData;
      if (!dataValuesSet.has(elementName)) {
        tempMasterElementMap[elementId] = {
          elementId,
          elementName,
          elementValue,
          elementType,
          mode: 2,
        };
      } else {
        // If the element is in data.value, find the corresponding mode from tempMasterElementGroup
        const group = tableMasterElement?.find(
          (item: any) => item.elementName === elementName,
        );
        if (group) {
          tempMasterElementMap[elementId] = {
            elementId,
            elementName,
            elementValue,
            elementType,
            mode: group.mode === 0 ? 0 : 1,
          };
        } else {
          tempMasterElementMap[elementId] = {
            elementId,
            elementName,
            elementValue,
            elementType,
            mode: 1,
          };
        }
      }
    });
    setSelectedTableMetaData(data.value);
    const uniqueData = Object.values(tempMasterElementMap);
    DashboardConfigurationStore.tableWithForm = {
      ...DashboardConfigurationStore.tableWithForm,
      tableMasterElement: JSON.stringify(uniqueData),
    };
  };

  const setFormMetaData = (_event: any, data: any) => {
    const tableMasterElement = JSON.parse(tableWithForm?.formMasterElement);
    const dataValuesSet = new Set(data.value);
    const tempMasterElementMap: any = {};
    tableWithForm.formMetadataOptions?.forEach((tempData: IFormDetails) => {
      const { elementId, elementName, elementType, elementValue } = tempData;
      if (!dataValuesSet.has(elementName)) {
        tempMasterElementMap[elementId] = {
          elementId,
          elementName,
          elementType,
          elementValue,
          mode: 2,
        };
      } else {
        // If the element is in data.value, find the corresponding mode from tempMasterElementGroup
        const group = tableMasterElement?.find(
          (item: any) => item.elementName === elementName,
        );
        if (group) {
          tempMasterElementMap[elementId] = {
            elementId,
            elementName,
            elementType,
            elementValue,
            mode: group.mode === 0 ? 0 : 1,
          };
        } else {
          tempMasterElementMap[elementId] = {
            elementId,
            elementName,
            elementType,
            elementValue,
            mode: 1,
          };
        }
      }
    });
    setSelectedFormMetaData(data.value);
    const uniqueData = Object.values(tempMasterElementMap);
    DashboardConfigurationStore.tableWithForm = {
      ...DashboardConfigurationStore.tableWithForm,
      formMasterElement: JSON.stringify(uniqueData),
    };
  };

  const switchFormMode = (data: IFormDetails) => {
    let tempMasterElement = JSON.parse(tableWithForm.formMasterElement || '[]');
    tempMasterElement?.forEach((tempData: IFormDetails) => {
      if (tempData.elementId === data.elementId) {
        tempData.mode = data.mode === 1 ? 0 : 1;
      }
    });
    DashboardConfigurationStore.tableWithForm = {
      ...DashboardConfigurationStore.tableWithForm,
      formMasterElement: JSON.stringify(tempMasterElement),
    };
  };

  const switchTableMode = (data: IFormDetails) => {
    let tempMasterElement = JSON.parse(
      tableWithForm.tableMasterElement || '[]',
    );
    tempMasterElement?.forEach((tempData: IFormDetails) => {
      if (tempData.elementId === data.elementId) {
        tempData.mode = data.mode === 1 ? 0 : 1;
      }
    });
    DashboardConfigurationStore.tableWithForm = {
      ...DashboardConfigurationStore.tableWithForm,
      tableMasterElement: JSON.stringify(tempMasterElement),
    };
  };

  const handleTableMasterChange = async (_e: any, data: any) => {
    tableWithForm.tableMasterElement = '[]';
    DashboardConfigurationStore.tableWithForm.tableLinkName = '';

    let tempMetaDataList: IFormDetails[] = [];
    let masterKey: string = '';
    tableWithForm.tableOptions?.forEach(async (master) => {
      if (master.value === data.value) {
        masterKey = master.key;
        return;
      }
    });
    if (masterKey !== '') {
      tempMetaDataList = await GETMasterMetaData(masterKey);
    }

    DashboardConfigurationStore.tableWithForm = {
      ...DashboardConfigurationStore.tableWithForm,
      tableMasterName: data.value,
      tableMasterId: masterKey,
      tableMetadataOptions: tempMetaDataList?.filter(
        (met) => met.isActive && !met.isDeleted,
      ),
      tableMasterElement:
        masterKey === '' ? '[]' : tableWithForm.tableMasterElement,
    };
  };

  const handleFormMasterChange = async (_e: any, data: any) => {
    tableWithForm.formMasterElement = '[]';
    DashboardConfigurationStore.tableWithForm.formLinkName = '';

    let tempMetaDataList: IFormDetails[] = [];
    let masterKey: string = '';
    tableWithForm.formOptions?.forEach(async (master) => {
      if (master.value === data.value) {
        masterKey = master.key;
        return;
      }
    });
    if (masterKey !== '') {
      tempMetaDataList = await GETMasterMetaData(masterKey);
    }
    DashboardConfigurationStore.tableWithForm = {
      ...DashboardConfigurationStore.tableWithForm,
      formMasterName: data.value,
      formMasterId: masterKey,
      formMetadataOptions: tempMetaDataList?.filter(
        (met) => met.isActive && !met.isDeleted,
      ),
      formMasterElement:
        masterKey === '' ? '[]' : tableWithForm.formMasterElement,
    };
  };

  const accordionHandleClick = (_e: any, titleProps: any) => {
    const { index } = titleProps;
    const newIndex = activeIndex === index ? -1 : index;

    setActiveIndex(newIndex);
  };

  const changeComparision = (
    _event: any,
    data: any,
    id: string,
    index: number,
  ) => {
    let tempMasterElement = JSON.parse(tableWithForm.tableMasterElement);
    tempMasterElement?.forEach((tempData: datagridMasterElementType) => {
      if (tempData.elementId === id) {
        if (tempData.criteria) {
          tempData.criteria[index] = {
            type: data.value || '',
            value: '',
          };
        }
      }
    });
    DashboardConfigurationStore.tableWithForm = {
      ...DashboardConfigurationStore.tableWithForm,
      tableMasterElement: JSON.stringify(tempMasterElement),
    };
  };

  const addValue = (
    _event: any,
    data: any,
    id: string,
    type: string = 'equals',
    index: any,
  ) => {
    let tempMasterElement = JSON.parse(tableWithForm.tableMasterElement);
    tempMasterElement?.forEach((tempData: IFormDetails) => {
      if (tempData.elementId === id) {
        if (tempData.criteria) {
          tempData.criteria[index] = {
            type,
            value: data.value,
          };
        }
      }
    });
    DashboardConfigurationStore.tableWithForm = {
      ...DashboardConfigurationStore.tableWithForm,
      tableMasterElement: JSON.stringify(tempMasterElement),
    };
  };

  const removeCriteria = (id: string, index: any) => {
    let tempMasterElement = JSON.parse(tableWithForm.tableMasterElement);
    tempMasterElement?.forEach((tempData: IFormDetails) => {
      if (tempData.elementId === id) {
        tempData = {
          ...tempData,
          criteria: tempData.criteria?.splice(index, 1),
        };
      }
    });
    DashboardConfigurationStore.tableWithForm = {
      ...DashboardConfigurationStore.tableWithForm,
      tableMasterElement: JSON.stringify(tempMasterElement),
    };
  };

  const handleCriteria = (id: any) => {
    let tempMasterElement = JSON.parse(tableWithForm.tableMasterElement);
    tempMasterElement?.forEach((tempData: IFormDetails) => {
      if (tempData.elementId === id) {
        if (tempData.criteria) {
          tempData.criteria?.push({
            type: '',
            value: '',
          });
        } else {
          tempData.criteria = [
            {
              type: '',
              value: '',
            },
          ];
        }
      }
    });
    DashboardConfigurationStore.tableWithForm = {
      ...DashboardConfigurationStore.tableWithForm,
      tableMasterElement: JSON.stringify(tempMasterElement),
    };
  };

  return (
    <Accordion vertical className="accordionWrapper">
      <Accordion.Title
        active={activeIndex === 0}
        index={0}
        onClick={accordionHandleClick}
      >
        <Icon name="dropdown" />
        Data Grid
      </Accordion.Title>
      <AccordionContent
        isTable
        activeIndex={activeIndex}
        index={0}
        options={tableWithForm.tableOptions}
        name={tableWithForm.tableMasterName}
        handleMasterChange={handleTableMasterChange}
        metadataList={tableMetaDataList}
        selectedMetadata={selectedTableMetaData}
        metadataHandler={setDataGridMetaData}
        masterElement={tableWithForm.tableMasterElement}
        switchMode={switchTableMode}
        flexBasis={tableWithForm.tableFlexBasis}
        setFlexBasis={(width: string) => (tableWithForm.tableFlexBasis = width)}
        changeComparision={changeComparision}
        addValue={addValue}
        removeCriteria={removeCriteria}
        handleCriteria={handleCriteria}
        showCriteria={showCriteria}
      />
      <Accordion.Title
        active={activeIndex === 1}
        index={1}
        onClick={accordionHandleClick}
      >
        <Icon name="dropdown" />
        Form
      </Accordion.Title>
      <AccordionContent
        activeIndex={activeIndex}
        index={1}
        options={tableWithForm.formOptions}
        name={tableWithForm.formMasterName}
        handleMasterChange={handleFormMasterChange}
        metadataList={formMetaDataList}
        selectedMetadata={selectedFormMetaData}
        metadataHandler={setFormMetaData}
        masterElement={tableWithForm.formMasterElement}
        switchMode={switchFormMode}
        flexBasis={tableWithForm.formFlexBasis}
        setFlexBasis={(width: string) => (tableWithForm.formFlexBasis = width)}
      />
    </Accordion>
  );
}

export default observer(DataGridWithForm);
